import React from 'react'
import '../App.css'
import imbolglogo from "../imbolglogo.png"

const Artists = () => {
  return (
    <div className="Audio">
      <p className="artist-name">Imbolg</p>
      <p className="artist-info">Imbolg is a New York City band founded by Singer and guitar player Nate Dal Cais. Named after the Celtic pagan holiday Imbolg(also spelled “Imbolc” or “Imbolic” and, sometimes misspelled as “Imblog”) creates dark, melodic and often heavy sounds mixed with synthesizers in various music Genres ranging from Gothic Metal to Punk and Old School Death Rock. Reminiscent of their main inspirations including such artists as : Type O Negative, the Misfits, Black Sabbath, Paradise Lost and the 69 eyes.</p>
      <a className="artist-link" href="https://imbolgmusic.com/">Imbolg Official Site</a>
      <img className="images" src={imbolglogo}/>
    </div>
  )
}

export default Artists;
